export const setSongGenresAction = (genres) => (dispatch) => {
    dispatch({
        type: "SET_ALL_GENRES",
        payload: {
            genres: genres
        }
    })
};